<template>
    <div>
        <div class="p-2 mb-5">
            <v-card-text class="p-4 mb-5">
                <h4 class="mb-5">Texte d'introduction du formulaire</h4>
                <ckeditor
                  :editor="editor"
                  :config="editorConfig"
                  v-model="txtIntroCasp"
                  @input="setTxtIntroCasp"
                ></ckeditor>
            </v-card-text>

            <v-card-text
              class="p-4 mb-5"
              id="configuration"
            >
                <h4 class="mb-5">Personnalisation du formulaire</h4>
                <div class="d-flex justify-content-between">
                    <div
                      style="width: 320px"
                      class="position-relative"
                    >
                        <div class="d-flex gap-10 align-items-end mb-3">
                            <h5>Styles</h5>

                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                      v-on="on"
                                      icon
                                      @click="resetStyle"
                                    >
                                        <v-icon color="primary">mdi-reload</v-icon>
                                    </v-btn>
                                </template>
                                <span>Réinitialiser tous les styles</span>
                            </v-tooltip>
                        </div>

                        <div class="mb-5 valid-button">
                            <div class="title-valid-button">Couleurs</div>

                            <div class="py-4 pb-0">
                                <div class="row">
                                    <div class="col p-0">
                                        <div
                                          class="d-flex mb-7 color-editor-div justify-content-center align-items-center flex-column text-center"
                                        >
                                            <div
                                              class="color-editor mb-3"
                                              :style="'background-color:' + caspPrimaryColor"
                                              @click="openColorDialog('caspPrimaryColor')"
                                            ></div>
                                            <v-label>Primaire</v-label>
                                        </div>
                                    </div>
                                    <div class="col p-0">
                                        <div
                                          class="d-flex mb-7 color-editor-div justify-content-center align-items-center flex-column text-center"
                                        >
                                            <div
                                              class="color-editor mb-3"
                                              :style="'background-color:' + caspTitlesColor"
                                              @click="openColorDialog('caspTitlesColor')"
                                            ></div>
                                            <v-label>Titres</v-label>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col">
                                        <div
                                          class="d-flex color-editor-div justify-content-center align-items-center flex-column text-center"
                                        >
                                            <div
                                              class="color-editor mb-3"
                                              :style="'background-color:' + caspFieldsColor"
                                              @click="openColorDialog('caspFieldsColor')"
                                            ></div>
                                            <v-label>Nom des champs</v-label>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div
                                          class="d-flex color-editor-div justify-content-center align-items-center flex-column text-center"
                                        >
                                            <div
                                              class="color-editor mb-3"
                                              :style="'background-color:' + caspBackGroundColorRgba"
                                              @click="openColorDialog('caspBackGroundColor')"
                                            ></div>
                                            <v-label>Fond</v-label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex mb-5 color-editor-div">
                            <v-select
                              :items="availableFonts"
                              outlined
                              label="Police d'écriture"
                              v-model="caspFontFamily"
                              @change="setCaspFontFamily"
                              return-object
                            >
                            </v-select>
                        </div>
                    </div>

                    <div style="width: calc(100% - 350px)">
                        <div class="d-flex gap-10 align-items-end mb-5">
                            <h5>Prévisualiser</h5>

                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                      v-on="on"
                                      icon
                                      @click="preparePreview"
                                    >
                                        <v-icon color="primary">open_in_new</v-icon>
                                    </v-btn>
                                </template>
                                <span>Voir le formulaire complet</span>
                            </v-tooltip>
                        </div>

                        <div
                          class="web-form-simulation"
                          id="pro-layout"
                          style="min-height: auto !important"
                          :style="'background-color:' + caspBackGroundColorRgba + ';font-family:' + caspFontFamily"
                        >
                            <div id="pro-cmaj-form">
                                <v-alert
                                  type="info"
                                  :color="caspPrimaryColor"
                                  v-if="txtIntroCasp !== null"
                                  class="mb-5 form-container mr-auto ml-auto"
                                  border="right"
                                  colored-border
                                >
                                    <div v-html="txtIntroCasp"></div>
                                </v-alert>

                                <div class="tabulation-title">
                                    <h5 :style="'color:' + caspTitlesColor">1. Informations générales</h5>
                                </div>

                                <div class="mt-3">
                                    <div>
                                        <label :style="'color:' + caspFieldsColor"> Langues parlées </label>
                                        <v-autocomplete
                                          chips
                                          :items="languages"
                                          deletable-chips
                                          item-text="name"
                                          v-model="selectedLanguages"
                                          return-object
                                          :item-color="caspPrimaryColor"
                                          multiple
                                          outlined
                                        >
                                            <template #selection="{ item }">
                                                <v-chip
                                                  :color="caspPrimaryColor"
                                                  close
                                                  @click:close="deleteChip(item, selectedLanguages)"
                                                >
                                                    {{ item.name }}
                                                </v-chip>
                                            </template>
                                        </v-autocomplete>
                                    </div>

                                    <div>
                                        <label :style="'color:' + caspFieldsColor"> Accueil de personnes en situation de
                                            handicap </label>
                                        <v-radio-group
                                          row
                                          class="mt-auto mb-auto"
                                          value="null"
                                          style="padding-top: 0 !important"
                                        >
                                            <v-radio
                                              :color="caspPrimaryColor"
                                              label="Oui"
                                              class="text"
                                              :value="true"
                                            >
                                            </v-radio>
                                            <v-radio
                                              :color="caspPrimaryColor"
                                              label="Non"
                                              class="text"
                                              :value="false"
                                            >
                                            </v-radio>
                                            <v-radio
                                              :color="caspPrimaryColor"
                                              label="Non communiqué"
                                              class="text"
                                              value="null"
                                            >
                                            </v-radio>
                                        </v-radio-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </v-card-text>
        </div>

        <v-dialog
          v-model="dialogHexa"
          max-width="300px"
          v-if="dialogHexa"
          content-class="color-picker-dialog"
        >
            <v-color-picker
              dot-size="25"
              v-model="currentColor"
              mode="hexa"
              @input="updateColor"
              swatches-max-height="200"
            >
            </v-color-picker>
        </v-dialog>

        <v-dialog
          v-model="dialogRgba"
          max-width="300px"
          v-if="dialogRgba"
          content-class="color-picker-dialog"
        >
            <v-color-picker
              dot-size="25"
              v-model="currentColor"
              mode="rgba"
              @input="updateColor"
              swatches-max-height="200"
            >
            </v-color-picker>
        </v-dialog>
    </div>
</template>

<script>
import ClassicEditor from "../../../../plugins/ckeditor"
import { mapMutations, mapState } from "vuex"

export default {
    name: "CaspFormConfigStep",
    props: ["provider", "languages", 'selectedLanguages'],
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {
                toolbar: {
                    shouldNotGroupWhenFull: true,
                    items: [
                        'heading',
                        '|',
                        'alignment',
                        'bold',
                        'italic',
                        'underline',
                        'fontSize',
                        'fontColor',
                        'fontBackgroundColor',
                        'link',
                        'bulletedList',
                        'numberedList',
                        'imageUpload',
                        'blockQuote',
                        'undo',
                        'redo'
                    ]
                },
            },
            dialogHexa: false,
            dialogRgba: false,
            currentColor: null,
            currentProperty: null,
        }
    },
    methods: {
        ...mapMutations("webFormStyle", [
            "setCaspFontFamily",
            "setCaspTitlesColor",
            "setCaspBackGroundColor",
            "setCaspPrimaryColor",
            "setCaspFieldsColor",
            "setTxtIntroCasp",
        ]),
        openColorDialog(vmProperty) {
            this.currentColor = this[vmProperty]
            this.currentProperty = vmProperty

            if (vmProperty === "caspBackGroundColor") {
                if (typeof this.currentColor !== "object") {
                    this.currentColor = this.rgbaStringToObject(this.currentColor)
                    this.setCaspBackGroundColor(this.currentColor)
                }

                this.dialogRgba = true
            } else {
                this.dialogHexa = true
            }
        },
        deleteChip(itemNeedToRemove, array) {
            for (let i = 0; i < array.length; i += 1) {
                if (array[i].id === itemNeedToRemove.id) {
                    array.splice(i, 1)
                }
            }

            this.$forceUpdate()
        },
        updateColor(value) {
            if (this.currentProperty === "caspFieldsColor") {
                this.setCaspFieldsColor(value)
            } else if (this.currentProperty === "caspBackGroundColor") {
                this.setCaspBackGroundColor(value)
            } else if (this.currentProperty === "caspTitlesColor") {
                this.setCaspTitlesColor(value)
            } else if (this.currentProperty === "caspPrimaryColor") {
                this.setCaspPrimaryColor(value)
                this.updateChipsColor()
            }
        },
        resetStyle() {
            this.setCaspPrimaryColor("#1398b5")
            this.setCaspTitlesColor("#000000")
            this.setCaspFieldsColor("#787d8f")
            this.setCaspFontFamily("Roboto, sans-serif")
            this.setCaspBackGroundColor({
                r: 245,
                b: 245,
                g: 245,
                a: 1,
            })

            this.updateChipsColor()
        },
        preparePreview() {
            if (typeof this.caspBackGroundColor !== "object") {
                this.setCaspBackGroundColor(this.rgbaStringToObject(this.caspBackGroundColor))
            }

            this.setCaspBackGroundColor(this.caspBackGroundColorRgba)

            let route = this.$router.resolve({ path: "/espace-pro/formulaire/" + this.provider.id + "?preview&casp" })

            window.open(route.href, "_blank")
        },
        updateChipsColor() {
            let chips = document.getElementsByClassName("v-chip")

            for (let chip of chips) {
                chip.style.setProperty("background-color", this.caspPrimaryColor, "important")
            }
        },
        rgbaStringToObject(backGroundColor) {
            let colors = ["r", "g", "b", "a"]

            let colorArr = backGroundColor.slice(backGroundColor.indexOf("(") + 1, backGroundColor.indexOf(")")).split(",")

            let obj = {}

            colorArr.forEach((k, i) => {
                obj[colors[i]] = k
            })

            return obj
        },
    },
    computed: {
        ...mapState("account", ["account"]),
        ...mapState("webFormStyle", [
            "caspFontFamily",
            "caspTitlesColor",
            "caspBackGroundColor",
            "caspPrimaryColor",
            "caspFieldsColor",
            "txtIntroCasp",
            "availableFonts",
        ]),
        caspBackGroundColorRgba() {
            return (
              "rgba(" +
              this.caspBackGroundColor.r +
              "," +
              this.caspBackGroundColor.g +
              "," +
              this.caspBackGroundColor.b +
              "," +
              this.caspBackGroundColor.a +
              ")"
            )
        },
    },
}
</script>
